import { useQueryClient } from '@tanstack/react-query';

import { getPropertyMappings, listRoomAmenities } from '~/services/AccommodationService';

import { propertyMappingQueryKeys } from './useGetPropertyLogoIdByReservationId';

const APPROVED_ROOM_AMENITIES_LIMIT = '100';

export const accommodationRoomAmenityQueryKeys = {
  all: ['accommodation', 'room-amenities'] as const,
  approved: (accommodationRoomId: string) =>
    [...accommodationRoomAmenityQueryKeys.all, accommodationRoomId, 'approved'] as const,
};

export function useGetAccommodationRoomAmenities() {
  const queryClient = useQueryClient();

  const fetchPropertyMapping = (reservationPropertyId: string) =>
    queryClient.fetchQuery({
      queryKey: propertyMappingQueryKeys.detail(reservationPropertyId),
      queryFn: async ({ signal }) => {
        const response = await getPropertyMappings({ reservationPropertyId }, { signal });
        return response.result;
      },
      // A 404 means the property isn't linked yet, which retrying won't change.
      retry: false,
    });

  const fetchApprovedRoomAmenityNames = (accommodationRoomId: string) =>
    queryClient.fetchQuery({
      queryKey: accommodationRoomAmenityQueryKeys.approved(accommodationRoomId),
      queryFn: async () => {
        const response = await listRoomAmenities(
          { roomId: accommodationRoomId },
          { status: 'approved', limit: APPROVED_ROOM_AMENITIES_LIMIT },
        );
        return response.result.amenities.map((amenity) => amenity.name);
      },
    });

  return { fetchApprovedRoomAmenityNames, fetchPropertyMapping };
}
